module.exports = __webpack_public_path__ + "img/1f9a6.4bfd67e.svg";